import { DiscountItems } from 'context-providers/cart-provider';

// productId looks something like "gid://shopify/Product/123456789"
export const discountAppliesToProduct = (
  productId: string | undefined | null,
  items: DiscountItems | undefined | null,
): boolean => {
  if (!productId || !items) return false;
  if (items.__typename === 'AllDiscountItems' || items.allItems) return true;
  if (items.products?.nodes?.some((p) => p.id === productId)) return true;
  if (
    items.collections?.nodes?.some((c) =>
      c.products?.nodes?.some((p) => p.id === productId),
    )
  )
    return true;
  return false;
};
